import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import translations, { LANGUAGES } from '../i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('kc_lang') || 'en';
    } catch (_) {
      return 'en';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('kc_lang', lang);
    } catch (_) {
      /* noop */
    }
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const dict = translations[lang] || translations.en;
    return { lang, setLang, t: dict, languages: LANGUAGES };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
